import React from "react";

import { FlexGrid, H1, SectionWrapper } from "src/components";

const PageHeader = ({ color, heading }) => (
  <SectionWrapper as="header" bg={color}>
    <div
      css={`
        padding-top: 96px;
        padding-bottom: 48px;
      `}
    >
      <FlexGrid gutterX={[8]}>
        <div
          css={`
            width: 67%;
            @media (max-width: 64rem) {
              width: 100%;
            }
          `}
        >
          <H1 children={heading} color="text.reverse" />
        </div>
      </FlexGrid>
    </div>
  </SectionWrapper>
);

export default PageHeader;
